module.exports = __webpack_public_path__ + "img/checkin_at_airport.6888a1fb.png";